const SERVICE_TYPES = [
    {
        name: 'Live Load/Unload',
        slug: 'live',
        localizationSlug: 'LIVE_LOAD_UNLOAD',
    },
    { name: 'Drop & Hook', slug: 'drop', localizationSlug: 'DROP_HOOK' },
];
module.exports = { SERVICE_TYPES };
